<div>
  <h2 *ngIf="data.title">{{data.title}}</h2>
  <h3 *ngIf="data.subTitle">{{data.subTitle}}</h3>
  <div *ngIf="data.text" [innerHTML]="data.text"></div>
  <br>
  <mat-grid-list cols="2" rowHeight="40px">
    <mat-grid-tile *ngFor="let btn of data.buttons">
      <button *ngIf="btn.type === 'flat' || !btn.type" mat-flat-button color="{{btn.color?btn.color:'accent'}}"
              (click)="btnAction(btn)">{{btn.name}}</button>
      <button *ngIf="btn.type === 'text'" mat-button color="{{btn.color?btn.color:'accent'}}"
              (click)="btnAction(btn)">{{btn.name}}</button>
      <button *ngIf="btn.type === 'outline'" mat-stroked-button color="{{btn.color?btn.color:'accent'}}"
              (click)="btnAction(btn)">{{btn.name}}</button>
    </mat-grid-tile>
  </mat-grid-list>
</div>
